export default __webpack_public_path__ + "static/media/cele-terminal.7dc6a5dc.png";